import type { PanelMenuDesignTokens } from '@primeuix/themes/types/panelmenu';

 export default {
    item: {
        gap: "0.5rem",
        icon: {
            color: "{navigation.item.icon.color}",
            focusColor: "{navigation.item.icon.focus.color}"
        },
        color: "{navigation.item.color}",
        padding: "{navigation.item.padding}",
        focusColor: "{navigation.item.focus.color}",
        borderRadius: "{content.border.radius}",
        focusBackground: "{navigation.item.focus.background}"
    },
    root: {
        gap: "0.5rem",
        transitionDuration: "{transition.duration}"
    },
    panel: {
        last: {
            borderWidth: "1px",
            bottomBorderRadius: "{content.border.radius}"
        },
        color: "{content.color}",
        first: {
            borderWidth: "1px",
            topBorderRadius: "{content.border.radius}"
        },
        padding: "0.25rem 0.25rem",
        background: "{content.background}",
        borderColor: "{content.border.color}",
        borderWidth: "1px",
        borderRadius: "{content.border.radius}"
    },
    submenu: {
        indent: "1rem"
    },
    submenuIcon: {
        color: "{navigation.submenu.icon.color}",
        focusColor: "{navigation.submenu.icon.focus.color}"
    }
} satisfies PanelMenuDesignTokens;